import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import * as React from "react";
import { primaryColor } from "vendor/colors";
import Button from "./Button";

export default function SplitButtonWithDdl({
  baseOption,
  onBaseOptionClick,
  options,
  renderOption,
  onOptionClick,
  button1Props,
  button2Props,
  closeOnSelection = true,
  dataQa,
}: {
  baseOption: string;
  onBaseOptionClick: () => void;
  options: string[];
  renderOption?: (option: string) => React.ReactNode;
  onOptionClick?;
  button1Props?: Record<string, any>;
  button2Props?: Record<string, any>;
  closeOnSelection?: boolean;
  dataQa?: string;
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleClick = () => onBaseOptionClick?.();

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    onOptionClick?.(options[index]);
    if (closeOnSelection) {
      setOpen(false);
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup ref={anchorRef} aria-label="split button" variant="text">
        <Button color="primary" onClick={handleClick} {...button1Props}>
          {baseOption}
        </Button>
        <Button
          color="primary"
          onClick={handleToggle}
          {...button2Props}
          style={{
            paddingLeft: "6px",
            paddingRight: "4px",
            marginLeft: "-1px",
            borderLeft: `1px solid ${primaryColor[1]}`,
            ...button2Props?.style,
          }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 3,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={index}
                      disabled={false}
                      selected={false}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {renderOption?.(option) || option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
